require.register("picture/app", function(exports, require, module){
  $0
  
});

